// extracted by mini-css-extract-plugin
export default {"base":"ModalPopup_base__rHO56","card":"ModalPopup_card__xa-9Y"};